import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Worker, Fichaje} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiControlService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** controles ***/

  getFichajes(): Promise<[Worker[], Fichaje[]]> {
    const url = `${this.apiUrl}controles`;
    return firstValueFrom(this.http.get<[Worker[], Fichaje[]]>(url))
  }
  getWorkers(): Promise<Worker[]> {
    const url = `${this.apiUrl}controles/workers`;
    return firstValueFrom(this.http.get<Worker[]>(url))
  }
  getFichajesTrabajadora(mes: number, year: number, id: number): Promise<Fichaje[]> {
    const url = `${this.apiUrl}controles/${mes}/${year}/${id}`;
    return firstValueFrom(this.http.get<Fichaje[]>(url))
  }
  resetTrabajadoraPIN(id: number): Promise<void> {
    const url = `${this.apiUrl}controles/pin/reset/${id}`;
    return firstValueFrom(this.http.get<void>(url))
  }
  updateTrabajadora(datos: Worker): Promise<any> {
    const url = `${this.apiUrl}controles/workers`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  printFichajes(datos: {nombre: string, fecha: string, mes: number, year: number, id: number}): Promise<any> {
    const url = `${this.apiUrl}controles/print`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  updateFichaje(datos: {id: number, moment: string}): Promise<any> {
    const url = `${this.apiUrl}controles/editar`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  setPin(datos: {id: number, pin: string}): Promise<any> {
    const url = `${this.apiUrl}controles/pin/update`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  addTrabajadora(data: Worker): Promise<number> {
    const url = `${this.apiUrl}controles/workers`;
    return firstValueFrom(this.http.put<number>(url, data))
  }
  insertFichaje(data: {idTrabajadora: number, moment?: string}): Promise<number> {
    const url = `${this.apiUrl}controles/fichajes`;
    return firstValueFrom(this.http.put<number>(url, data))
  }
  checkPin(data: {id: number, pin: string}): Promise<any> {
    const url = `${this.apiUrl}controles/pin/check`;
    return firstValueFrom(this.http.put<any>(url, data))
  }
  borrarTrabajadora(id: number): Promise<any> {
    const url = `${this.apiUrl}controles/worker/${id}`;
    return firstValueFrom(this.http.delete<any>(url))
  }
  deleteFichaje(id: number): Promise<any> {
    const url = `${this.apiUrl}controles/${id}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
